export default __webpack_public_path__ + "static/media/bikeOffline.bc95e074.png";